import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ReportsAllFiltersAppyModels } from '../../models/reports-all-filter-appy.models';
import { ChatBotModule, IInitializeModel, IQuestionModel } from 'src/app/modules/shared/components/chatbot-modal/model/chatbot.model';
import { SavedSearchesService } from 'src/app/misc/saved-searches/services/saved-searches.service';
import { MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { Severity } from 'src/app/inventory/constants/constants';
import { DashboardAvailableFilterTypes } from '../../../profile/dashboard/models/dashboard-add-content-filters.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from 'src/app/modules/shared/stores/ngrx.imports';
import { selectorDashboardSavedsearchReportsAllData } from 'src/app/modules/shared/stores/dashboardSavedsearchReportsDataStore/dashboardSavedsearchReportsData.selectors';
import { DashboardSavedsearchReportsFiltersModels } from 'src/app/models/dashboard-savedsearch-reports/dashboard-savedsearch-reports-filter.models';
import { getDashboardSavedsearchReportsdData } from 'src/app/modules/shared/stores/dashboardSavedsearchReportsDataStore/dashboardSavedsearchReportsData.compare';
import { DashboardSavedsearchReportsModels } from 'src/app/modules/shared/stores/dashboardSavedsearchReportsDataStore/dashboardSavedsearchReportsData.state';
import { DashboardSavedsearchReportsSuccessAction } from 'src/app/modules/shared/stores/dashboardSavedsearchReportsDataStore/dashboardSavedsearchReportsData.actions';
import { TimeZoneService } from 'src/app/modules/shared/services/timezone.service';

@Component({
    selector: 'app-dashboard-savedsearch-reports',
    templateUrl: './dashboard-savedsearch-reports.component.html',
    styleUrls: ['./dashboard-savedsearch-reports.component.scss'],
    providers: []
})
export class DashboardSavedsearchReportsComponent implements OnInit, OnChanges, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() selectedReportFilters: any = null;
    @Input() reloadContent: boolean = false;
    @Output() onReloadContent: EventEmitter<any> = new EventEmitter<any>();
    @Output() onLastReloadTime: EventEmitter<any> = new EventEmitter<Date>();
    @Input() selectedWindow: string = '';
    @Input() displayFilterPopup: boolean = false;
    @Output() onCloseFilterPopup: EventEmitter<any> = new EventEmitter<any>();
    @Output() onUpdateAllFilters: EventEmitter<ReportsAllFiltersAppyModels> = new EventEmitter<ReportsAllFiltersAppyModels>();

    chartType: string = 'image';
    chartData: any;
    moduleName: string = 'SavedSearch';
    sessionId: string;
    chatBotInitializationData: any;
    showSpinner: boolean = false;
    constructor(private savedSearchesService: SavedSearchesService,
        private messageService: MessageService,
        private titlecasePipe: TitleCasePipe,
        private store: Store<RootReducerState>,
        private timeZoneService: TimeZoneService
    ) {

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.reloadContent && changes?.reloadContent?.currentValue) {
            this.reloadContent = true;
            // this.send(true);
            this.initialize(this.chatBotInitializationData, true);
        }

    }

    ngOnInit(): void {
        if (this.selectedReportFilters?.length > 0) {
            if (!this.chatBotInitializationData) {
                this.chatBotInitializationData = {};
                this.chatBotInitializationData.selectedSearch = { id: this.selectedReportFilters?.find(x => x.filterType == DashboardAvailableFilterTypes.SavedSearchId)?.filterValue ?? 0 };
                this.chatBotInitializationData.query = this.selectedReportFilters?.find(x => x.filterType == DashboardAvailableFilterTypes.SavedSearchBotQuery)?.filterValue ?? null;
            }
            this.initialize(this.chatBotInitializationData);
        }
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    initialize(chatBotInitializationData, reloadContent: boolean = false) {
        const getReportsData = this.store.select(selectorDashboardSavedsearchReportsAllData);

        const addedFilters: DashboardSavedsearchReportsFiltersModels = {
            savedSearchId: this.chatBotInitializationData?.selectedSearch?.id,
            query: this.chatBotInitializationData?.query,
            sessionId: null
        }
        getReportsData.subscribe(storedData => {
            const results = getDashboardSavedsearchReportsdData(storedData, this.selectedWindow, addedFilters);
            if (results.index > -1 && !this.reloadContent) {
                const updatedTime: Date = results?.data?.loadedTime ? new Date(results?.data?.loadedTime) : new Date();
                this.onLastReloadTime.emit(updatedTime);
                this.setReportsResponse(results?.data?.reportsData || []);
            } else {
                this.loadInitialize(chatBotInitializationData, addedFilters, reloadContent);
            }

        });

    }
    loadInitialize(chatBotInitializationData, addedFilters: DashboardSavedsearchReportsFiltersModels, reloadContent: boolean = false) {
        if (this.moduleName == ChatBotModule.Journal) {
            // this.showSpinner = true;
            // this.financeService.journalInitialize()
            //     .pipe(takeUntil(this.ngUnsubscribe$))
            //     .subscribe({
            //         next: (response) => {
            //             this.sessionId = response?.sessionId;
            //             this.chatBotInitializationData.sessionId = response?.sessionId;
            //             this.showSpinner = false;
            //             // this.getSampleQuestions(this.sessionId);
            //         },
            //         error: (error) => {
            //             this.showSpinner = false;
            //             this.messageService.add({
            //                 severity: Severity.Error,
            //                 summary: this.titlecasePipe.transform(Severity.Error),
            //                 detail: "Error occurred...",
            //             });
            //         }
            //     });
        }
        else if (this.moduleName == ChatBotModule.SavedSearch) {
            if (reloadContent) {
                this.chartData = null;
            }
            let initializationData: IInitializeModel = {
                savedSearchId: chatBotInitializationData?.selectedSearch?.id ?? 0,
                savedSearchName: '', //this.removeSpecialCharacters(chatBotInitializationData?.selectedSearch?.name)
            }
            this.showSpinner = true;
            this.savedSearchesService.initialize(initializationData)
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe({
                    next: (response) => {
                        this.sessionId = response?.sessionId;
                        this.chatBotInitializationData.sessionId = response?.sessionId;
                        addedFilters.sessionId = response?.sessionId ?? null;
                        this.send(addedFilters, reloadContent);
                    },
                    error: (error) => {
                        this.showSpinner = false;
                        this.messageService.add({
                            severity: Severity.Error,
                            summary: this.titlecasePipe.transform(Severity.Error),
                            detail: "Error occurred...",
                        });
                    }
                });
        }
    }

    send(addedFilters: DashboardSavedsearchReportsFiltersModels, reloadContent: boolean = false) {
        let questionData: IQuestionModel = {
            question: this.chatBotInitializationData?.query?.trim(),
            sessionId: this.chatBotInitializationData?.sessionId,
            ianatimezone: this.timeZoneService.getUserIANATimeZone()
        }
        if (this.moduleName == ChatBotModule.Journal) {
            // this.financeService.journalAskQuestion(questionData)
            //     .pipe(takeUntil(this.ngUnsubscribe$))
            //     .subscribe({
            //         next: (res) => {
            //             if (res) {
            //                 this.removeTypingIndicatorMessage();
            //                 this.prepareResponseMessage(res, questionData.question);
            //             }
            //             setTimeout(() => this.scrollToBottom(), 100);
            //         },
            //         error: (error) => {
            //             this.removeTypingIndicatorMessage();
            //             this.chatMessages.push({
            //                 message: "Couldn't process your request !!!",
            //                 image: "",
            //                 user: this.receiver,
            //                 messageType: "text",
            //                 queryId: 0,
            //                 query: ""
            //             });
            //         }
            //     });
        }
        else if (this.moduleName == ChatBotModule.SavedSearch) {
            this.savedSearchesService.askQuestion(questionData)
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe({
                    next: (res) => {
                        this.showSpinner = false;
                        if (res?.figure) {
                            this.chartData = res.figure ? `data:image/png;base64,${res.figure}` : "";
                            this.setDashboardSavedSearchStoreData(this.chartData, addedFilters);
                        }
                        this.onReloadContent.emit(false);
                    },
                    error: (error) => {
                        this.showSpinner = false;
                        this.onReloadContent.emit(false);
                    }
                });
        }

    }

    setReportsResponse(responseData) {
        this.chartData = responseData;
    }

    setDashboardSavedSearchStoreData(results: any, addedFilters: DashboardSavedsearchReportsFiltersModels) {
        const reportsData: DashboardSavedsearchReportsModels = {
            reportsData: results,
            reportType: this.selectedWindow,
            loadedTime: new Date(),
            addedFilters: addedFilters,
            loading: false,
            loaded: true
        }

        this.store.dispatch(new DashboardSavedsearchReportsSuccessAction(reportsData));
    }
}
